import { combineReducers } from 'redux';
import activityReducer from './reducers/activityReducer';
import sessionReducer from './reducers/sessionReducer';
import roundReducer from './reducers/roundReducer';
import alexReducer from './reducers/alexReducer';
import placeholderReducer from './reducers/placeholderReducer';
import dragAndDropReducer from './reducers/dragAndDropReducer';
import instructionReducer from './reducers/instructionReducer';
import practiceReducer from './reducers/practiceReducer';
import onboardingReducer from './reducers/onboardingReducer';
import bonusGameReducer from './reducers/bonusGameReducer';
import bonusGameModalReducer from './reducers/bonusGameModalReducer';

export default combineReducers({
  activityReducer,
  sessionReducer,
  roundReducer,
  alexReducer,
  placeholderReducer,
  dragAndDropReducer,
  instructionReducer,
  practiceReducer,
  onboardingReducer,
  bonusGameReducer,
  bonusGameModalReducer,
});
